import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/pages/Home.vue'
import Quiz from '@/pages/Quiz.vue'
import Result from '@/pages/Result.vue'
import Ranking from '@/pages/Ranking.vue'
import Records from '@/pages/Records.vue'
import Login from '@/pages/Login.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/quiz',
    name: 'Quiz',
    component: Quiz
  },
  {
    path: '/result',
    name: 'Result',
    component: Result
  },
  {
    path: '/ranking',
    name: 'Ranking',
    component: Ranking
  },
  {
    path: '/records',
    name: 'Records',
    component: Records
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 简化路由守卫，只处理url参数中的uid更新
router.beforeEach((to, from, next) => {
  // 从路由参数中获取uid
  const urlUid = to.query.uid
  
  // 如果有url参数中的uid，更新到localStorage
  if (urlUid) {
    localStorage.setItem('uid', urlUid)
  }
  
  // 允许所有路由访问
  next()
})

export default router